import React from 'react';
import cn from 'classnames';

import {getAssetUrl} from 'coreUtils/adapters/sdk';

import Image from 'brandComponents/Image';

import {ISpinnerProps} from './ISpinner';

import styles from './Spinner.module.scss';

const Spinner = ({
	src = 'static/img/service_menu/loader.gif',
	type = 'default',
	fullScreen = false,
	block
}: ISpinnerProps) => {
	const spinnerSrc = getAssetUrl(src);

	if (type === 'rounded') {
		return (
			<div className={cn(
				'spinner',
				styles['spinner'],
				styles['spinner--rounded'],
				{
					[styles['spinner--block']]: block,
					[styles['spinner--full-screen']]: fullScreen
				}
			)}>
				<div className={cn('spinner__body', styles['spinner__body'])}></div>
			</div>
		);
	}

	return <Image src={spinnerSrc} alt="" showSkeleton={false} />;
};

export default Spinner;
